module.exports = __webpack_public_path__ + "static/media/Logo_1.3bd36774.svg";